import script from "./SliderImageSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderImageSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./SliderImageSkeleton.vue?vue&type=style&index=0&id=0c4633ae&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\artware\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c4633ae"]])

export default __exports__